import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSadTear } from '@fortawesome/free-regular-svg-icons';

const NotFound = () => (
    <div className='notfound'>
        <FontAwesomeIcon icon={faSadTear} />
    </div>
);

export default NotFound;
